import { customAlphabet } from 'nanoid';

const nano = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz', 16);

export const ID_PREFIX = {
  user: 'usr',
  session: 'ses',
  account: 'acc',
  verification: 'ver',
  workspace: 'wsp',
  member: 'mem',
  invite: 'inv',
  team: 'tem',
  teamMember: 'tmm',
  space: 'spc',
  folder: 'fld',
  list: 'lst',
  grant: 'grt',
  statusSet: 'sts',
  status: 'sta',
  customField: 'cfd',
  fieldValue: 'cfv',
  task: 'tsk',
  tag: 'tag',
  dependency: 'dep',
  taskLink: 'tlk',
  checklist: 'chk',
  checklistItem: 'chi',
  comment: 'cmt',
  reaction: 'rct',
  attachment: 'att',
  activity: 'act',
  recurrence: 'rec',
  view: 'viw',
  timeEntry: 'tme',
  timeBlock: 'tbk',
  taskTeam: 'ttm',
  channel: 'chn',
  channelMember: 'chm',
  message: 'msg',
  doc: 'doc',
  docPage: 'pag',
  docUpdate: 'dup',
  docVersion: 'dvr',
  whiteboard: 'wbd',
  form: 'frm',
  formField: 'fmf',
  submission: 'sub',
  dashboard: 'dsh',
  widget: 'wdg',
  clip: 'clp',
  notification: 'ntf',
  reminder: 'rmd',
  automation: 'aut',
  automationRun: 'run',
  importJob: 'imp',
  adminAction: 'adm',
  email: 'eml',
  event: 'evt',
  token: 'tok',
  webhook: 'whk',
  template: 'tpl',
  apiToken: 'tok',
  agentOperation: 'aop',
  agentWrite: 'awr',
  listVisit: 'lvi',
  pushSubscription: 'psh',
  officeFloor: 'flr',
  officeRoom: 'orm',
  officeItem: 'oit',
  officeLog: 'olg',
  officeMeeting: 'omt',
  generic: 'row',
} as const;

export type IdKind = keyof typeof ID_PREFIX;

export function newId(kind: IdKind): string {
  return `${ID_PREFIX[kind]}_${nano()}`;
}

/** Opaque random token for invites, share links, unsubscribe links. */
export function newToken(length = 32): string {
  return customAlphabet('0123456789abcdefghijklmnopqrstuvwxyz', length)();
}
